import { render } from "./parametrizacionleycapitulo.vue?vue&type=template&id=7f401b8f"
import script from "./parametrizacionleycapitulo.vue?vue&type=script&lang=js"
export * from "./parametrizacionleycapitulo.vue?vue&type=script&lang=js"

import "./parametrizacionleycapitulo.vue?vue&type=style&index=0&id=7f401b8f&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__